import { inject } from 'mobx-react';
import * as React from 'react';
import ESDataTableWithHeader from 'src/common/ESDataTableWithHeader';
import IDataTableManager from 'src/common/IDataTableManager';
import { DefaultRegion, IRegion } from 'src/Definitions';
import { IStores } from 'src/Stores';
import RegionDialog from './RegionDialog';

interface IRegionsProps {
    dataTableManager?: IDataTableManager<IRegion>;
    disableRegion?: (region: IRegion) => void;
    getColumnSettingsAndRegions?: () => void;
    isModalOpen?: boolean;
    openDialogWithRegion?: (region: IRegion) => void;
    recoverRegion?: (region: IRegion) => void;
}

@inject((stores: IStores) => ({
    dataTableManager: stores.regions.dataTableStore,
    disableRegion: stores.regions.disableRegion,
    getColumnSettingsAndRegions: stores.regions.getColumnSettingsAndRegions,
    isModalOpen: stores.regions.isModalOpen,
    openDialogWithRegion: stores.regions.openDialogWithRegion,
    recoverRegion: stores.regions.recoverRegion,
}))
class Regions extends React.Component<IRegionsProps> {
    public componentDidMount() {
        this.props.getColumnSettingsAndRegions!();
    }

    public render() {
        const regionDialog = this.props.isModalOpen && <RegionDialog />;
        return (
            <>
                <ESDataTableWithHeader
                    dataTableManager={this.props.dataTableManager!}
                    enableEdit={true}
                    enableReorderColumns={true}
                    enableSearch={true}
                    enableShowInactives={true}
                    enableToggleColumns={true}
                    openDialog={this.openDialog(DefaultRegion(true))}
                    title="Regions"
                />
                {regionDialog}
            </>
        );
    }

    public openDialog = (region: IRegion) => () => {
        this.props.openDialogWithRegion!(region);
    };
}

export default Regions;



// WEBPACK FOOTER //
// ./src/regions/Regions.tsx